import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";

const api = new APIClient();

const RESOURCE = "/waitlists";

export type WaitlistShift = "morning" | "afternoon" | "evening" | "any";

export interface WaitlistClient {
  id: number;
  name: string;
}

export interface WaitlistProfessional {
  id: number;
  name: string;
}

export interface WaitlistUnit {
  id: number;
  name: string;
}

export interface WaitlistEntry {
  id: number;
  tenant_id: number;
  unit_id: number;
  client_id: number;
  professional_id: number | null;
  date: string;
  shift: WaitlistShift;
  status: string;
  client?: WaitlistClient;
  professional?: WaitlistProfessional | null;
  unit?: WaitlistUnit;
  created_at: string;
  updated_at: string;
}

export interface CreateWaitlistPayload {
  unit_id: number;
  client_id: number;
  professional_id?: number | null;
  date: string;
  shift: WaitlistShift;
}

export interface WaitlistListParams extends PaginationParams {
  unit_id?: number;
}

export const getAll = (
  params?: WaitlistListParams
): Promise<PaginatedApiResponse<WaitlistEntry>> =>
  api.get<PaginatedApiResponse<WaitlistEntry>>(RESOURCE, params);

export const create = (
  payload: CreateWaitlistPayload
): Promise<ApiResponse<WaitlistEntry>> =>
  api.create<ApiResponse<WaitlistEntry>>(RESOURCE, payload);
